module.exports = __webpack_public_path__ + "static/media/13.9f46f1d2.jpeg";